import { filterWorkshopOrders, summarizeWorkshop } from './workshopDashboard.js'
import { matchesOrderSearch } from './searchStats.js'
import { findWorkshopInterval, workshopOrderDate, workshopTimestamp } from './workshopIntervals.js'

export const filterRosOrders = (orders, filters = {}) => filterWorkshopOrders(orders, { ...filters, search: '' })
    .filter(order => matchesOrderSearch(order, filters.search || '', ['car_brand', 'car_model', 'plate', 'client_name', 'client_phone', 'mechanic_name', 'master_name', 'number', 'vin']))

const average = values => values.length ? Math.round(values.reduce((sum, value) => sum + value, 0) / values.length) : null
const elapsed = (end, start) => {
    const a = workshopTimestamp(end), b = workshopTimestamp(start)
    return a && b ? (a - b) / 60000 : null
}
const interest = rows => {
    const eligible = rows.filter(order => order.is_sent && order.client_interest_score != null)
    const details = order => order.client_interest_details || {}
    const opened = eligible.filter(order => Number(details(order).visits) >= 1)
    const percent = predicate => eligible.length ? Math.round(eligible.filter(predicate).length / eligible.length * 100) : null
    return {
        total: eligible.length,
        avg_score: average(eligible.map(order => Number(order.client_interest_score))),
        visits_pct: percent(order => Number(details(order).visits) >= 1),
        scroll_pct: percent(order => details(order).scrolled === true),
        photos_pct: percent(order => details(order).photoOpened === true),
        actions_pct: percent(order => details(order).actionTaken === true),
        // As in the existing server summary, time is averaged over opened reports only.
        avg_time_min: average(opened.flatMap(order => details(order).timeSpentSeconds == null ? [] : [Number(details(order).timeSpentSeconds)])),
    }
}

export function summarizeRos(orders, intervals = []) {
    const rows = [...new Map(orders.map(order => [order.id, order])).values()]
    const summary = summarizeWorkshop(rows, intervals)
    const staff = (idKey, nameKey, duration) => {
        const people = new Map()
        for (const order of rows) {
            if (order[idKey] == null) continue
            if (!people.has(order[idKey])) people.set(order[idKey], { id: order[idKey], name: order[nameKey] || 'Неизвестный сотрудник', total: 0, sent: 0, expired: 0, times: [] })
            const person = people.get(order[idKey])
            person.total++
            if (order.is_sent) person.sent++
            if (['expired_open', 'expired_progress'].includes(order.outcome)) person.expired++
            const minutes = duration(order)
            if (minutes != null) person.times.push(minutes)
        }
        return [...people.values()].map(({ times, ...person }) => ({ ...person, avg_minutes: average(times) }))
            .sort((a, b) => b.total - a.total || a.name.localeCompare(b.name, 'ru'))
    }
    const buckets = intervals.map(() => [])
    for (const order of rows) {
        const index = findWorkshopInterval(intervals, workshopOrderDate(order))
        if (index !== -1) buckets[index].push(order)
    }
    const totals = interest(rows)
    return {
        ...summary,
        avgDiagMinutes: summary.avgWorkMinutes,
        mechanicStats: staff('mechanic_id', 'mechanic_name', order => elapsed(order.in_progress_at, order.created_at)),
        masterStats: staff('master_id', 'master_name', order => order.outcome === 'approved' ? elapsed(order.approved_at, order.in_progress_at) : null),
        vibe: {
            totals,
            totalSent: totals.total, avgScore: totals.avg_score ?? 0,
            openedPct: totals.visits_pct ?? 0, actionsPct: totals.actions_pct ?? 0, avgTimeMin: totals.avg_time_min ?? 0,
            dynamics: intervals.map((interval, index) => ({ ...interval, ...interest(buckets[index]) })),
        },
    }
}
